import { useEffect, useMemo, useState, type ReactNode } from "react";
import { ThemeContext } from "./theme-context";
import { applyTheme, DARK_MEDIA_QUERY, readThemePreference, THEME_STORAGE_KEY, type Theme } from "./theme";

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(readThemePreference);

  useEffect(() => {
    const systemPreference = window.matchMedia?.(DARK_MEDIA_QUERY);
    const syncTheme = () => applyTheme(theme);

    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // The selected theme still applies when storage is unavailable.
    }
    syncTheme();

    if (theme === "system") systemPreference?.addEventListener("change", syncTheme);
    return () => systemPreference?.removeEventListener("change", syncTheme);
  }, [theme]);

  const value = useMemo(() => ({ theme, setTheme }), [theme]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
